import { render } from "./CircularChart.vue?vue&type=template&id=91cda84e"
import script from "./CircularChart.vue?vue&type=script&lang=js"
export * from "./CircularChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__